<template>
  <div>
    <!-- Delete Confirmation Of Benestare-->
    <v-dialog
      content-class="artDialog"
      persistent
      v-model="benestaredeletedialog"
      width="unset"
    >
      <v-card>
        <v-toolbar dense class="indigo darken-1 headline">
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-6">
          <h3 style="text-align: left !important">
            Sei sicuro di voler eliminare questo elemento?
          </h3>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="benestaredeletedialog = false">
            ANNULLA
          </v-btn>
          <v-btn color="green" dark @click="deleteBenestare">CONFERMA</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog In case of Many Articolo -->
    <v-dialog v-model="dialog_gestione_articoli" width="800">
      <v-card>
        <v-toolbar dark color="indigo">
          <v-toolbar-title>Articoli</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn small light @click="dialog_gestione_articoli = false">
            <v-icon color="red"> mdi-close </v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="max-height: 500px; overflow-y: auto">
          <v-data-table :headers="headers_articoli" :items="items_articoli">
            <template v-slot:[`item.details`]="{ item }">
              <v-col md="4">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-on="on"
                      v-bind="attrs"
                      style="float: left"
                      @click="selectArticolo(item)"
                      small
                    >
                      <v-icon color="primary">mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Aggiungi</span>
                </v-tooltip>
              </v-col>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card witdh="unset">
      <v-toolbar color="indigo" dense>
        <v-toolbar-title class="white--text">Benestare</v-toolbar-title>
        <v-spacer></v-spacer>
        <Button
          classe_bottone="ml-2"
          colore_icona="primary"
          idForm="QUALITA"
          idOggetto="CREA_BENESTARE"
          mdi_icona="mdi-plus"
          testo_tooltip="Aggiungi Benestare"
          v-on:buttonClick="aggiungiBenestare"
        />
        <v-spacer></v-spacer>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" @click="clickChiudi" small>
              <v-icon color="error">mdi-keyboard-backspace</v-icon>
            </v-btn>
          </template>
          <span>Torna al menu</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-row justify="center">
          <v-col cols="1"></v-col>
          <v-col class="py-0" cols="4" md="6">
            <v-text-field
              v-on:keydown.enter.prevent="searchArticolo"
              v-model="cod_articolo"
              label="Cod. Articolo"
            >
            </v-text-field>
          </v-col>
          <v-col class="py-0" cols="3" md="2">
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="searchArticolo"
                  v-bind="attrs"
                  v-on="on"
                  small
                  style="top: 20px; right: 50px"
                  ><v-icon color="primary">mdi-magnify</v-icon></v-btn
                >
              </template>
              <span>Cerca</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="12">
            <v-data-table :headers="headers_benestare" :items="items_benestare">
              <template v-slot:[`item.detail`]="{ item }">
                <Button
                  colore_icona="primary"
                  idForm="QUALITA"
                  idOggetto="MODIFICA_BENESTARE"
                  mdi_icona="mdi-pencil"
                  testo_tooltip="Dettaglio Benestare"
                  v-on:buttonClick="dettaglio_benestare(item)"
                />
              </template>
              <template v-slot:[`item.delete`]="{ item }">
                <Button
                  colore_icona="error"
                  idForm="QUALITA"
                  idOggetto="ELIMINA_BENESTARE"
                  mdi_icona="mdi-window-close"
                  testo_tooltip="Cancellare"
                  v-on:buttonClick="
                    benestaredeletedialog = true;
                    setitem(item);
                  "
                />
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

<!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />

    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import Button from "@/components/TOOLS/FormComponentPermissions/Button.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  components: {
    Button,
    SnackbarQV,
  },
  data() {
    return {
      // Overlay Variable
      cod_articolo: null,
      selectedBenestare: {},
      
      // benestaredeletedialog
      
      // Modal
      benestaredeletedialog: false,
      dialog_gestione_articoli: false,
      overlay: false,
      
      // Array
      headers_articoli: [
        {
          text: "",
          value: "details",
          sortable: false,
        },
        {
          text: "Cod Articolo",
          value: "cod_articolo",
          sortable: false,
        },
        {
          text: "Des Articolo",
          value: "des_articolo",
          sortable: false,
        },
        {
          text: "Famiglia",
          value: "id_famiglia",
          sortable: false,
        },
        {
          text: "Tipo",
          value: "id_tipo",
          sortable: false,
        },
        {
          text: "Tipo Fornitura",
          value: "id_tipo_fornitura",
          sortable: false,
        },
      ],
      headers_benestare: [],
      items_articoli: [],
      items_benestare: [],
    };
  },
  methods: {
    // IN order to show the delete dialog
    setitem(item) {
      this.selectedBenestare = item;
      this.benestaredeletedialog = true;
    },
    // In order to Get the Detail of Articolo from dialog of Articoli
    selectArticolo(item) {
      this.cod_articolo = item.cod_articolo;
      this.id_articolo = item.id_articolo;
      this.getBenestare();
      this.dialog_gestione_articoli = false;
    },
    // In orderto Directly Search the Articolo
    searchArticolo() {
      this.overlay = true;
      let search_Articolo = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          token: localStorage.getItem("user_token"),
          cod_articolo: this.cod_articolo,
        },
      };
      // Eseguo la chiamata al BE
      this.$store.dispatch("api", search_Articolo).then((res) => {
        if (res.data.lista.length == 0) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Nessun rticolo trovato per questo codice."
          );
          this.loadingVal = false;
          this.progressBar = false;
          this.overlay = false;
          this.savebutton = false;
          this.topDiv = true;
        }
        if (res.data.lista.length > 1) {
          this.overlay = false;
          this.dialog_gestione_articoli = true;
          this.items_articoli = res.data.lista;
        }
        if (res.data.lista.length == 1) {
          this.overlay = false;
          this.id_articolo = res.data.lista[0].id_articolo;
          this.cod_articolo = res.data.lista[0].cod_articolo;
          this.getBenestare();
          // Getting Ciclo lista to populate the table
        }
      });
    },
    // GetPiano Controlo
    getBenestare() {
      this.items_benestare = [];
      this.headers_benestare = [];
      let getBenestare = {
        controller: "Qualita",
        method: "POST",
        richiesta: {
          action: "getbenestare",
          token: localStorage.user_token,
          id_benestare: "",
          id_articolo: this.id_articolo,
        },
      };
      this.$store.dispatch("api", getBenestare).then((res) => {
        /* Se non ci sono elementi di benestare stampo
         * una snackbar di avviso e non vado oltre. */
        if (res.data.lista.length == 0) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Non esistono istruzioni di Benestare a Produrre per questo articolo."
          );
          return;
        }

        // Se c'è un solo benestare, vado direttamente al suo dettaglio.
        if (res.data.lista.length == 1) {
          this.go_dettaglio_benestare(res.data.lista[0]);
        }

        /* Se ci sono più elementi di benestare, carico gli header che
         * mi passa il BE e consento all'utente di selezionare la riga
         * che gli interessa di più. */
        if (res.data.lista.length > 1) {
          /* Aggiungo l'header per la modifica. */
          let edit = {
            value: "detail",
            sortable: false,
          };
          this.headers_benestare.push(edit);

          // Aggiungo gli header mandati dal BE.
          res.data.header.forEach((h) => {
            this.headers_benestare.push(h);
          });

          /* Aggiungo l'header per la cancellazione. */
          let del = {
            value: "delete",
            sortable: false,
          };
          this.headers_benestare.push(del);

          // Resetto la lista degli elementi e la popolo.
          this.items_benestare = new Array();
          res.data.lista.forEach((b) => {
            this.items_benestare.push(b);
          });
        }
      });
    },
    go_dettaglio_benestare(item) {
      this.$router.push({
        name: "BenestareDetail",
        params: {
          foo: item.id_benestare,
        },
      });
    },
    // In order to Remove single ciclo auto  controllo
    deleteBenestare() {
      this.overlay = true;
      this.selectedBenestare.validita = 0;
      let delBenestare = {
        controller: "qualita",
        method: "PUT",
        richiesta: {
          action: "setbenestare",
          token: localStorage.user_token,
          qm_benestare: [this.selectedBenestare],
          id_benestare: this.selectedBenestare.id_benestare,
        },
      };
      this.$store.dispatch("api", delBenestare).then(() => {
        this.overlay = false;
        let i = this.items_benestare.findIndex(
          (it) => it.id_benestare == this.selectedBenestare.id_benestare
        );
        this.items_benestare.splice(i, 1);
        this.$refs.SnackbarQV.print(
          "success",
          "Modifica effettuata con successo!"
        );
        this.selectedBenestare = {};
        this.benestaredeletedialog = false;
      });
    },
    // Function to get us back to Main menu
    clickChiudi() {
      this.id_articolo = "";
      this.cod_articolo = "";
      this.items_benestare = [];
      this.$route.params.id = null;
      this.$emit("click_chiudi");
    },
    // Function trigger with PLus button in order to navigate to Creation Form
    aggiungiBenestare() {
      this.$router.push({
        name: "BenestareDetail",
        params: {
          foo: -1,
        },
      });
    },
    // Function trigger with Pencil button in order to navigate to Detail page
    dettaglio_benestare(item) {
      this.$router.push({
        name: "BenestareDetail",
        params: {
          foo: item.id_benestare,
          id_articolo: this.id_articolo,
        },
      });
    },
  },
  mounted() {
    // Popolo la tabella
    if (this.$route.params.id > 0) {
      this.overlay = true;
      let getBenestare = {
        controller: "qualita",
        method: "POST",
        richiesta: {
          action: "getbenestare",
          token: localStorage.user_token,
          id_benestare: "",
          id_articolo: this.$route.params.id,
        },
      };
      this.$store
        .dispatch("api", getBenestare)
        .then((res) => {
          this.overlay = false;

          if (res.status === 200) {
            // Resetto gli oggetti della tabella di benestare.
            this.items_benestare = new Array();

            // Se ci sono elementi di benestare li aggiungo, altrimenti stampo una snackbar.
            if (res.data.lista.length == 0) {
              this.$refs.SnackbarQV.print(
                "orange",
                "Non esiste un ciclo autocontrollo per questo articolo."
              );
            } else {
              this.items_benestare = res.data.lista;
            }

            // Resetto l'array degli headaers.
            this.headers_benestare = new Array();

            /* Aggiungo l'header per la modifica. */
            let edit = {
              value: "detail",
              text: "Modifica",
              sortable: false,
            };
            this.headers_benestare.push(edit);

            // Aggiungo gli header che mi passa il backend.
            res.data.header.forEach((h) => {
              this.headers_benestare.push(h);
            });

            /* Aggiungo l'header per la cancellazione. */
            let del = {
              value: "delete",
              text: "Elimina",
              sortable: false,
            };
            this.headers_benestare.push(del);

            this.dialog_gestione_articoli = false;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    }
  },
};
</script>
